<template>
  <div class="exp-info-wrap">
    <div class="exp-info">
      <div class="info-item">
        <div class="left">预约设备(座位)</div>
        <div class="right">{{dataObj.product_type_name}}</div>
      </div>
      <div class="info-item">
        <div class="left">设备(座位)序号</div>
        <div class="right">{{ dataObj.serial_no }}</div>
      </div>
      <div class="info-item">
        <div class="left">体验时间</div>
        <div class="right" style="color: yellow">
          {{ dataObj.date }}
          {{dataObj.startTime}}-{{dataObj.endTime}}
        </div>
      </div>
      <div class="info-item">
        <div class="left">体验时长</div>
        <div class="right">{{ dataObj.allTime }}分钟</div>
      </div>
      <div class="info-item">
        <div class="left">馆内地址</div>
        <div class="right">{{dataObj.addr}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["dataObj"],
};
</script>
<style lang="less" scoped>
.exp-info-wrap {
  padding: 20px;
  font-size: 0.35rem;
  color: #fff;
  .exp-info {
    background-color: #006feb;
    padding: 40px;
    border-radius: 20px;
    .info-item {
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>